import React, { useEffect, useState } from "react";
import { array, object, string, number } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import assetify from "@quintype/framework/assetify";

import LiveStoryContent from "../../molecules/LiveStoryContent";
import CardImage from "../../atoms/CardImage";
import DefaultImage from "../../atoms/CardImage/default.svg";

import { getStory } from "../../helper/api";
import DfpAd from "../../dfp-ad";

import "./liveBlog.m.css";

const LiveBlogTemplate = ({ story, imageElements, publisherAttributes, jwtToken, scrollIndex }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const [newStory, setNewStory] = useState(story);
  const isClosed = get(story, ["metadata", "is-closed"], false);

  useEffect(() => {
    global.deviceWidth < 876 && setIsMobile(!isMobile);
    global.deviceWidth > 1263 && setIsDesktop(!isDesktop);

    if (!isClosed) {
      const interval = setInterval(() => {
        getStory(story.id).then((response) => {
          if (response.story.metadata["is-closed"]) {
            clearInterval(interval);
          }
          setNewStory(response.story);
        });
      }, 60000);
      return () => clearInterval(interval);
    }
  }, []);

  return (
    <div styleName="wrapper">
      <div styleName="ad-slot" className="top-ad">
        <DfpAd
          adtype={publisherAttributes === "en" ? "EnPalo_ROS_728x90_T1" : "News_728x90_T1"}
          targetStory={story}
          slotId={`story_${scrollIndex}-t1`}
        />
      </div>
      {story["hero-image-s3-key"] && (
        <div>
          <CardImage
            story={newStory}
            widths={isMobile ? [375] : [1140]}
            aspectRatio={isMobile ? [16, 9] : [1200, 574]}
            imageType={isMobile ? "image3x2" : "image1200x574"}
            showStoryTypeIcon={false}
          />
        </div>
      )}
      <LiveStoryContent
        story={newStory}
        slicedStoryCards={newStory.cards}
        isLiveBlog={true}
        imageElements={imageElements}
        jwtToken={jwtToken}
        datatrackingcategory="Live Sub Section"
        datatrackingaction="Click"
        scrollIndex={scrollIndex}
        isDesktop={isDesktop}
      />
      {scrollIndex < 2 && (
        <div className="sun-logo">
          <img src={`${assetify(DefaultImage)}`} alt="sun" />
        </div>
      )}
    </div>
  );
};

const LiveBlog = ({ story, imageElements, publisherAttributes, jwtToken, scrollIndex }) => (
  <div className="story-grid">
    <LiveBlogTemplate
      story={story}
      imageElements={imageElements}
      publisherAttributes={publisherAttributes}
      jwtToken={jwtToken}
      scrollIndex={scrollIndex}
    />
  </div>
);

LiveBlogTemplate.propTypes = {
  story: object.isRequired,
  imageElements: array,
  publisherAttributes: object,
  jwtToken: string,
  scrollIndex: number,
};

LiveBlog.propTypes = {
  story: object.isRequired,
  imageElements: array,
  publisherAttributes: object,
  jwtToken: string,
  scrollIndex: number,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  jwtToken: get(state, ["userReducer", "jwt_token"], null),
});

export default connect(mapStateToProps, null)(LiveBlog);
